import * as S from '@effect/schema/Schema'

export const GETSearchCountiesResponse = S.Array(S.Struct({
  fips: S.String,
  state: S.String,
  name: S.String,
}))

export type GETSearchCountiesResponse = S.Schema.Type<typeof GETSearchCountiesResponse>
